import XLSX from 'xlsx'

import {
  ParsedSpreadsheet,
  SpreadsheetData
} from '@/types/spreadsheet-utils.types'

const getWorkbook = (binaryString: string): XLSX.WorkBook => {
  return XLSX.read(binaryString, { type: 'binary' })
}

const getWorksheet = (workbook: XLSX.WorkBook, index: number) => {
  const worksheetName = workbook.SheetNames[index]
  return workbook.Sheets[worksheetName]
}

export const parseSpreadsheetFile = (file: File, headers: string[], range: string): Promise<ParsedSpreadsheet> => {
  const fileReader = new FileReader()

  return new Promise((resolve, reject) => {
    fileReader.onerror = () => {
      fileReader.abort()
      reject()
    }

    fileReader.onload = (e) => {
      try {
        const workbook = getWorkbook(e?.target?.result as string || '')
        const worksheet = getWorksheet(workbook, 0)

        const data = XLSX.utils.sheet_to_json(worksheet, {
          raw: false,
          header: headers,
          range
        }) as SpreadsheetData

        resolve({
          sheetName: file.name,
          data
        })
      } catch (error) {
        reject(error)
      }
    }

    fileReader.readAsBinaryString(file)
  })
}
